import React, { useRef } from "react";
import TextField from "@mui/material/TextField";

const NumberTextField = ({ label, value, onChange, sx, InputProps, ...props }) => {
  const inputRef = useRef(null);
  const preventWheel = (e) => e.preventDefault();

  const handleKeyDown = (event) => {
    if (event.key === "e" || event.key === "E") {
      event.preventDefault();
      onChange("0");
    }
  };

  const handleChange = (event) => {
    const raw = event.target.value;

    // Si e/E passe quand même (copier-coller)
    if (raw.includes("e") || raw.includes("E")) {
      onChange("0");
      return;
    }

    const cleaned = raw.replace(/[^0-9]/g, "");
    onChange(cleaned);
  };

  const handleFocus = (event) => {
    event.target.addEventListener("wheel", preventWheel, { passive: false });
  };

  const handleBlur = (event) => {
    event.target.removeEventListener("wheel", preventWheel);
  };

  return (
    <TextField
      label={label}
      value={value}
      inputRef={inputRef}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      type="number"
      inputMode="numeric"
      pattern="[0-9]*"
      onFocus={handleFocus}
      onBlur={handleBlur}
      InputProps={{
        ...InputProps,
        sx: {
          
          borderRadius: "10px",
          backgroundColor: "background.paper",
          px: { xs: 1.1, md: 1.3 },
          py: { xs: 1, md: 1 },
        },
      }}
      sx={{
        "& input::placeholder": {
          color: "text.secondary",
          opacity: 1,
        },
        "& .MuiOutlinedInput-root": {
          fontSize: { xs: "1.1rem", md: "1rem" },
          "& fieldset": {
            borderColor: "divider",
          },
          "&:hover fieldset": {
            borderColor: "#5E17EB",
            borderWidth: 2,
          },
          "&.Mui-focused fieldset": {
            borderWidth: 2,
            borderColor: "#5E17EB",
          },
        },
        ...sx,
      }}
      {...props}
    />
  );
};

export default NumberTextField;
